/**
 * Helper function that detects when window.AmexSession is set, and configures Script Supplier accordingly.
 * Waits a quarter second before trying to read AmexSession.
 */
function waitForAmexSession(): void {
    // @ts-ignore
    if (window.AmexSession === undefined) {
        setTimeout(waitForAmexSession, 250);
    } else {
        // @ts-ignore
        window.AmexSession.options({
            zIndex: 999999
        });
    }
}

/** Provides an interface for loading and configuring Script Supplier, Amex One Identity's Universal Session Manager (USM), Adobe, and ContentSquare */
export default class ScriptSupplierService {
    private static readonly SCRIPT_ID = 'usm-service-script';

    /**
     * Idempotent loader that generates a script to load Script Supplier.
     * Does nothing if REACT_APP_SCRIPT_SUPPLIER_SRC is undefined
     */
    public static loadSSToPage(): void {
        const srcLoc = process.env.REACT_APP_SCRIPT_SUPPLIER_SRC;
        const integrityHash = process.env.REACT_APP_SCRIPT_SUPPLIER_HASH;
        // Check if the script exists already,
        if (srcLoc && integrityHash && document.getElementById(ScriptSupplierService.SCRIPT_ID) == null) {
            const script = document.createElement('script');
            script.src = srcLoc;
            script.integrity = integrityHash;
            script.crossOrigin = 'anonymous';
            script.async = true;
            script.id = ScriptSupplierService.SCRIPT_ID;

            window.scriptSupplierPageLocale = 'en-US';
            window.scriptSupplierPreset = [
                {
                    name: 'one-identity-session',
                    version: '^1.0.0'
                },
                {
                    name: 'trackit',
                    version: '^1.9.2'
                },
                {
                    name: 'adobe',
                    version: '^1.0.0',
                    async: true,
                    config: {
                        market: 'en-US',
                        businessUnit: 'myca'
                    }
                },
                {
                    name: 'contentsquare',
                    version: '^1.0.0'
                }
            ];
            document.body.appendChild(script);
            waitForAmexSession();
        }
    }
}
